import { createActions, createReducer } from 'reduxsauce';
import { ICustomSlider } from 'pages/Quotes/components/CustomSlider/interface';

export const { Types, Creators } = createActions({
  openCustomSlider: ['data'],
  closeCustomSlider: [],
});

const INITIAL_STATE: ICustomSlider = {
  content: undefined,
  state: {}
};

const openCustomSlider = (state = INITIAL_STATE, action: any) => ({
  ...action.data, show: true
});

const closeCustomSlider = (state = INITIAL_STATE, action: any) => ({
  content: undefined
});

export default createReducer(INITIAL_STATE, {
  [Types.OPEN_CUSTOM_SLIDER as any]: openCustomSlider,
  [Types.CLOSE_CUSTOM_SLIDER as any]: closeCustomSlider
});